import { IRestClientRequestOptions, HttpStatusCode } from '@gem/modules/restClient';
import { parseJSON } from '@gem/utils';

import { ProjectUrls } from 'APP/packages/projectUrls/ProjectUrls';
import { ApiError, isApiErrorResponse } from 'APP/restApi/error/ApiError';
import Entities from 'STORE';
import { getUserLanguage } from 'UTILS/getUserLanguage';

import { ServerErrorCode } from '../constants/constants';
import { bffRestClient } from './restClient';
import { sessionExpiredHandler } from './sessionExpiredHandler';

export function configureRestClient(): void {
  bffRestClient.addRequestInterceptor(
    (options: IRestClientRequestOptions): IRestClientRequestOptions => {
      const accessToken = Entities.authStore.connectionToken;
      return {
        ...options,
        useRawReqData: true,
        baseUrl: `${ProjectUrls.bffUrl}/api/v1`,
        headers: {
          ...options.headers,
          authorization: accessToken ? `Bearer ${accessToken}` : '',
          locale: getUserLanguage(),
          'Content-Type': 'application/protobuf',
          credentials: 'include',
        },
      };
    }
  );

  bffRestClient.addResponseInterceptor(
    (response) => response.data,
    (error) => {
      const errorResponse = parseJSON(error?.responseData || '');
      const apiErrorResponse = isApiErrorResponse(errorResponse) ? errorResponse : null;

      const apiError = new ApiError(
        apiErrorResponse?.error.message || '',
        apiErrorResponse?.error.code || error.statusCode || HttpStatusCode.Unknown,
        error.requestEndpoint,
        error.requestOptions,
        apiErrorResponse,
        error.responseHeaders,
        error
      );

      if (apiError.message === ServerErrorCode.SessionExpired) {
        const prevAccessToken = Entities.authStore.connectionToken;

        return new Promise((resolve, reject) => {
          sessionExpiredHandler(apiError, prevAccessToken, resolve, reject);
        });
      }
      return apiError;
    }
  );
}
